import { render, staticRenderFns } from "./AcceptRejectedDoc.vue?vue&type=template&id=2192ed3a&"
import script from "./AcceptRejectedDoc.vue?vue&type=script&lang=js&"
export * from "./AcceptRejectedDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports